import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import {select, Store} from '@ngrx/store';
import {Observable, take, takeUntil, tap} from 'rxjs';
import {SeFeAnchorDirective, SeFeButtonDirective} from 'se-fe-button';
import {NavigationEventService} from '../../../../../add-ons/navigation-event.service';
import {AddressFormGroup, OnDestroySubject} from '../../../../../data/model';
import {AddOnFooterStore, AddOnFooterViewModel} from './add-on-footer.store';
import {Router} from '@angular/router';
import {MultipleRegistrations} from '../../../../context-data/context-data';
import {selectMultipleRegistrations} from '../../../../context-data/context-data.selectors';

@Component({
  selector: 'app-add-on-footer',
  templateUrl: './add-on-footer.component.html',
  styleUrls: ['./add-on-footer.component.scss'],
  host: {class: 'app-add-on-footer-element'},
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AddOnFooterStore],
  standalone: false,
})
export class AddOnFooterComponent extends OnDestroySubject {
  @ViewChild('continueEle') continueEle:
    SeFeButtonDirective | SeFeAnchorDirective;

  @Output() continueToCheckoutClick = new EventEmitter<void>();
  @Output() continueClick = new EventEmitter<void>();
  @Output() registerAnotherPersonClick = new EventEmitter<void>();

  multipleRegistrations$: Observable<MultipleRegistrations | undefined>;
  vm$: Observable<AddOnFooterViewModel> = this.footerStore.vm$;

  constructor(
    private footerStore: AddOnFooterStore,
    private navigationEventService: NavigationEventService,
    private router: Router,
    private store: Store,
  ) {
    super();
    this.navigationEventService.continueClick
      .pipe(takeUntil(this.onDestroy))
      .subscribe(() => {
        this.continueEle.elementRef.nativeElement.click();
      });
    this.multipleRegistrations$ = this.store.pipe(
      select(selectMultipleRegistrations),
      takeUntil(this.onDestroy),
    );
  }

  get disableNextButton(): Observable<boolean> {
    return this.footerStore.disableNextButton$;
  }
  @Input() set disableNextButton(value: boolean | Observable<boolean>) {
    this.footerStore.setDisableNextButton(value);
  }

  @Input() set displayRegisterAndCompleteButtons(value: boolean) {
    this.footerStore.setDisplayRegisterAndCompleteButtons(value);
  }

  continue(fragment: string): void {
    if (fragment) {
      this.router.navigate([{outlets: {commerceElement: fragment}}]);
    }
    this.vm$
      .pipe(
        take(1),
        tap(vm => {
          if (vm.motionRegistrantAddress) {
            this.handleGomoAddress(vm.motionRegistrantAddress);
          } else {
            this.continueClick.emit();
          }
        }),
      )
      .subscribe();
  }

  private handleGomoAddress(address: AddressFormGroup): void {
    this.footerStore.setMotionAddress(address);
  }
}
